/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        AOS.init();


        (function($) {
          //Progress Bar on Top
          window.onscroll = function() {myFunction()};
          function myFunction() {
            var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
            var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
            var scrolled = (winScroll / height) * 100;
            document.getElementById("pBar").style.width = scrolled + "%";
          }

          function VerticalTimeline( element ) {
            this.element = element;
            this.blocks = this.element.getElementsByClassName("js-st-block");
            this.images = this.element.getElementsByClassName("js-st-img");
            this.contents = this.element.getElementsByClassName("js-st-content");
            this.offset = 0.8;
            this.hideBlocks();
          };

          VerticalTimeline.prototype.hideBlocks = function() {
            //hide timeline blocks which are outside the viewport
            if ( !"classList" in document.documentElement ) {
              return;
            }
            var self = this;
            for( var i = 0; i < this.blocks.length; i++) {
              (function(i){
                if( self.blocks[i].getBoundingClientRect().top > window.innerHeight*self.offset ) {
                  self.images[i].classList.add("st-is-hidden");
                  self.contents[i].classList.add("st-is-hidden");
                }
              })(i);
            }
          };

          VerticalTimeline.prototype.showBlocks = function() {
            if ( ! "classList" in document.documentElement ) {
              return;
            }
            var self = this;
            for( var i = 0; i < this.blocks.length; i++) {
              (function(i){
                if( self.contents[i].classList.contains("st-is-hidden") && self.blocks[i].getBoundingClientRect().top <= window.innerHeight*self.offset ) {
                  // add bounce-in animation
                  self.images[i].classList.add("st-timeline__img--bounce-in");
                  self.contents[i].classList.add("st-timeline__content--bounce-in");
                  self.images[i].classList.remove("st-is-hidden");
                  self.contents[i].classList.remove("st-is-hidden");
                }
              })(i);
            }
          };

          var verticalTimelines = document.getElementsByClassName("js-st-timeline"),
            verticalTimelinesArray = [],
            scrolling = false;
          if( verticalTimelines.length > 0 ) {
            for( var i = 0; i < verticalTimelines.length; i++) {
              (function(i){
                verticalTimelinesArray.push(new VerticalTimeline(verticalTimelines[i]));
              })(i);
            }

            //show timeline blocks on scrolling
            window.addEventListener("scroll", function(event) {
              if( !scrolling ) {
                scrolling = true;
                (!window.requestAnimationFrame) ? setTimeout(checkTimelineScroll, 250) : window.requestAnimationFrame(checkTimelineScroll);
              }
            });
          }

          function checkTimelineScroll() {
            verticalTimelinesArray.forEach(function(timeline){
              timeline.showBlocks();
            });
            scrolling = false;
          };

        })(jQuery);

        //Toggle Search
        $( ".js-search-overlay-trigger" ).click(function() {
          $( ".search-overlay-wrapper" ).addClass('search-overlay-wrapper--is-open');
          $( 'body' ).addClass('body--search-is-open');
        });
        $( ".js-search-close-trigger" ).click(function() {
          $( ".search-overlay-wrapper" ).removeClass('search-overlay-wrapper--is-open');
          $( 'body' ).removeClass('body--search-is-open');
        });

        //FullScroll
        /*$(document).ready(function() {
          $('#fullpage').fullpage();
        });*/

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // Play videos once on scroll

        /** Utility Function */
        $.fn.isOnScreen = function(){
          var win = $(window);
          var viewport = {
              top : win.scrollTop(),
              left : win.scrollLeft()
          };
          viewport.right = viewport.left + win.width();
          viewport.bottom = viewport.top + win.height();

          var bounds = this.offset();
          bounds.right = bounds.left + this.outerWidth();
          bounds.bottom = bounds.top + this.outerHeight();
          return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
        };

        const hasPlayed = [];
        $(window).on('resize scroll', function() {
          $('.card-panel__video').each(function(i) {
            if ($(this).isOnScreen() && hasPlayed.indexOf(i) === -1) {
              $(this).trigger('play');
              $(this).on('ended', function() {
                hasPlayed.push(i);
              });
            }
          });
        });

      (function($) {

        $('[data-toggle=tab]').on('click', function(){
          if ($(this).parent().hasClass('active')){
            $($(this).attr("href")).toggleClass('active');
          }
        });

      })(jQuery);

        //Persona Slider
        jQuery(document).ready(function(){
          jQuery('.personas-slider').slick({
            infinite: true,
            dots: true,
            arrows: false
          });
        });

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    //FullScroll
    'ceos':{
      init: function() {
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    'security': {
      init: function () {
        var $tabsContainer = $('.nav-tabs--dynamicbg'),
          $tabs = $tabsContainer.find('li');

        $('a[data-toggle="tab"]').on('show.bs.tab', function (e) {
          $tabs.removeClass('nav-item--active');
          $(this).closest('li').addClass('nav-item--active');

          $('.nav-tabs__bg').animate({
            left: e.target.parentNode.offsetLeft
          }, 200);
        })
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
